import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import useSWR from 'swr';
import { useTranslation } from 'react-i18next';
import { getCurrency } from '../../utils/general';
import api from '../../api';
import { getCalculatorResults } from '../../utils/calculatorProHelper';

interface PreviousBidAmountProps {
  companyInfo: any;
  id: string;
}

const PreviousBidAmount: React.FC<PreviousBidAmountProps> =
  function PreviousBidAmount({ id, companyInfo }) {
    const [show, setShow] = useState(false);
    const [lead, setLead] = useState<any>(null);
    const [leadApi, setLeadApi] = useState<boolean>(false);
    const [bidAmount, setBidAmount] = useState<number>(0);
    const { t } = useTranslation();

    const { data: leadData } = useSWR(
      leadApi ? id : null,
      api.leadsApi.leadApi.getLead
    );

    const showAmount = () => {
      setShow(!show);
      if (id && !lead && !show) {
        setLeadApi(true);
      }
    };

    useEffect(() => {
      if (leadData) {
        setLead(leadData);
        setBidAmount(
          getCalculatorResults({ ...leadData, company: companyInfo })?.pricing
            ?.annualPrice
        );
      }
    }, [leadData]);

    return (
      <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'row' }}>
        <Button
          onClick={() => showAmount()}
          size="small"
          sx={{ marginBottom: 1 }}
          variant="text"
        >
          {show ? <VisibilityOff /> : <Visibility />}
        </Button>
        {show && (
          <Typography color="text.secondary" variant="body2">
            {t('LEAD.CREATE.ANALYSIS.previousBidAmount')}:{' '}
            <b>{getCurrency(bidAmount)}</b>
          </Typography>
        )}
      </Box>
    );
  };

export default PreviousBidAmount;
